import { ExpressionRule } from "../../rule-engine-core/Expressions/ExpressionRule";
import { AppGlueError } from "../../rule-engine-core/AppGlueError";
import { ExpressionRuleEditorBase } from "./ExpressionRuleEditorBase";

export abstract class ExpressionRuleEditor<T extends ExpressionRule> extends ExpressionRuleEditorBase {
    ruleData?: T;

    getExpressionRule(): ExpressionRule {
        if (!this.ruleData) throw new AppGlueError("no rule data");

        return this.ruleData;
    }
}
